




import {Component, Mixins} from "vue-property-decorator";
import CustomerContractInformation from "@/components/customer/customerContractInformation.vue";
import Authority from "@/common/mixins/authority";

@Component({
  name: "ContractInformationPage",
  components: {
    CustomerContractInformation,
  },
})
export default class ContractInformation extends Mixins(Authority) {}
